var path = 'app/scripts/modules/amazon/src/serverGroup/configure/wizard/loadBalancers/loadBalancers.html';
var html = "<div>\n  <aws-server-group-load-balancer-selector command=\"command\"></aws-server-group-load-balancer-selector>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/serverGroup/configure/wizard/loadBalancers/loadBalancers.html
// module id = 1242
// module chunks = 0